export const actions = {
    async getWebThemeOptionsById({ dispatch, commit }, { webThemeId }) {
        const loadedWebTheme = await dispatch('useApiData', {
            name: 'WebGetTheme',
            parameters: { id: webThemeId }
        });
        commit('ADD_WEBTHEME', loadedWebTheme.data);
        return loadedWebTheme;
    },
    async getWebThemeBaseLayersLayersById({ dispatch }, { webThemeId }) {
        return dispatch('useApiData', {
            name: 'WebGetBaseLayers',
            parameters: { id: webThemeId }
        });
    },
    async getWebThemeLayersById({ getters, dispatch }, { mapName, webThemeId }) {
        const layers = await dispatch('useApiData', {
            name: 'WebGetThemeLayers',
            parameters: { id: webThemeId }
        });
        if (!layers?.data) {
            return;
        }

        const print = getters.getWebTheme?.data.showPrint;
        const webThemeExportable = getters.getWebTheme?.data.exportable;
        const themeId = getters.getWebTheme.data.themeId;
        const layerPromises = layers?.data?.map(_layerData => dispatch('addLayer',
            {
                type: 'theme',
                layerData: { ..._layerData, themeId, print, exportable: _layerData.exportable && webThemeExportable },
                active: false,
                updateMap: true
            }
        ));
        await Promise.all(layerPromises);
        layers?.data
            .filter(({ visible }) => visible === true)
            .map(layer => dispatch('addLayerToMap', { mapName, id: layer.id }));
    },
    async refreshWebFeedback({ dispatch, getters }, { mapName }) {
        const id = getters.getAllOrderedFeedbacks[0].layerId;
        dispatch('addLayerToMap', { mapName, id });
    },
    async getWebStorageLayersById({ dispatch, commit }, { mapName, webThemeId }) {
        const feedbackLayers = await dispatch('useApiData', {
            name: 'WebGetFeedbackStorageLayers',
            parameters: { id: webThemeId }
        });
        const measurementLayers = await dispatch('useApiData', {
            name: 'WebGetMeasurementStorageLayers',
            parameters: { id: webThemeId }
        });

        const layers = [...feedbackLayers?.data ?? [], ...measurementLayers?.data ?? []];

        if (layers.length > 0) {
            const layerId = layers[0].id;
            const feedbackId = layers[0].feedbackTypeId;
            const feedbackData = await dispatch('useApiData', {
                name: 'WebGetStorageLayerType',
                parameters: { storageLayerId: feedbackId }
            });
            const contentTypeId = feedbackData.data.contentTypeId;

            commit('ADD_FEEDBACK', {
                layerId,
                feedbackData: {
                    ...feedbackData.data,
                    feedbackType:
                    {
                        contentTypeId,
                        feedbackFields: feedbackData.data.feedbackFields,
                        geometryType: feedbackData.data.geometryType,
                        useInWebTheme: feedbackData.data.useInWebTheme
                    }
                },
                active: true
            });

            const layerPromises = layers.map(_layerData => dispatch('addLayer',
                {
                    type: 'feedback',
                    layerData: { ..._layerData, feedbackId, contentTypeId },
                    active: false,
                    updateMap: true
                }
            ));
            await Promise.all(layerPromises);
            layers?.map(layer => dispatch('addLayerToMap', { mapName, id: layer.id }));
        }
    },
    async toggleAllLayers({ dispatch, getters }, { mapName, active }) {
        const toggledLayersPromisses = getters.getAllOrderedLayers
            .filter(layer => layer.type !== 'base')
            .map(layer => dispatch('toggleLayer', { mapName, id: layer.id, active }));
        return Promise.all(toggledLayersPromisses);
    },
    async toggleLayer({ dispatch, getters }, { mapName, id, active }) {
        if (active) {
            await dispatch('setFilters', { layer: getters.getLayerById(id) });
            await dispatch('addLayerToMap', { mapName, id });
        } else {
            await dispatch('removeLayerFromMap', { mapName, id });
        }
    }
};
